import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../../uiComponents/MuiTable/StyledTable.js';
import MuiTableHeader from '../../../../uiComponents/MuiTable/MuiTableHeader.js';
import { stableSort, getComparator, handleRequestSort } from '../../../../uiComponents/MuiTable/MuiHelper.js';
import { TableBody, TableContainer } from '@mui/material';
import StatusIcon from '../../../../icons/StatusIcon.js';

const PatientAbnormalBiomarkersConditionsTable = ({ data }) => {
  if (!data || data.length === 0) return null;
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('acronym');

  const headCells = [
    { label: 'Condition', id: 'acronym', numeric: false, disablePadding: false },
    { label: 'Biomarker(s)', id: 'cutofFormula', numeric: false, disablePadding: false },
    { label: 'Value Status', id: 'valueStatus', numeric: false, disablePadding: false },
    { label: 'Flagged Status', id: 'flaggedStatus', numeric: false, disablePadding: false },
    { label: 'Reason', id: 'reason', numeric: false, disablePadding: false, type: 'noSort' },
  ];

  // Flatten data for sorting: extract primary/secondary codes from reason array
  const tableRows = data.map(row => {
    const reasons = row.reason || [];

    const primaryCodes = [...new Set(
      reasons
        .map(r => r.cutoffFomula)
        .filter(code => code != null && code.trim() !== '')
        .flatMap(code => code.split(','))
    )].join(', ');

    const reasonTexts = reasons.map(r => r.reason).filter(Boolean).join('; ');

    return {
      acronym: row.acronym,
      cutoffFormula: primaryCodes,
      valueStatus: row.valueStatus,
      flaggedStatus: <StatusIcon status={row.flaggedStatus}/>,
      reasons: reasonTexts,
    };
  });
  
  return (
    <TableContainer component={StyledPaper} sx={{ maxHeight: 400, overflowY: 'auto' }}>
      <StyledTable
        size='small'
        aria-label="abnormal biomarkers conditions table"
        key={JSON.stringify(data)}
      >
        <MuiTableHeader
          stickyHeader={true}
          headCells={headCells}
          order={order}
          orderBy={orderBy}
          onRequestSort={(event, property) => handleRequestSort(event, property, order, orderBy, setOrder, setOrderBy)}
        />
        <TableBody>
          {stableSort(tableRows, getComparator(order, orderBy)).map((row, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>{row.acronym || '-'}</StyledTableCell>
              <StyledTableCell>{row.cutoffFormula || '-'}</StyledTableCell>
              <StyledTableCell>{row.valueStatus || '-'}</StyledTableCell>
              <StyledTableCell>{row.flaggedStatus || '-'}</StyledTableCell>
              <StyledTableCell>{row.reasons || '-'}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </StyledTable>
    </TableContainer>
  );
};

export default PatientAbnormalBiomarkersConditionsTable;